import store from '@/store'

const contractorsRoute = [
    {
        path: 'ch/:companyId?',
        name: 'project-contractors',
        meta: {
            title: 'project_menu.contractors',
            requireProject: true,
            permission: ['contractor.view_details'],
        },
        props: true,
        component: () => import('@/views/Project/ch/index.vue'),
        beforeEnter: (to, from, next) => {
            if (store.getters.authenticated) {
                next()
            } else {
                next({ name: 'SignIn', query: { url: to.fullPath } })
            }
        },
    },
    {
        path: 'ch/:projectId?/:companyId?',
        name: 'group-contractors',
        meta: {
            title: 'project_menu.contractors',
            requireProject: true,
            permission: ['contractor.view_details'],
        },
        props: true,
        component: () => import('@/views/Project/ch/index.vue'),
        beforeEnter: (to, from, next) => {
            if (store.getters.authenticated) {
                next()
            } else {
                next({ name: 'SignIn', query: { url: to.fullPath } })
            }
        },
    },
]

export { contractorsRoute }
